// lib
import { combineReducers } from "redux";
import { filterActions } from "redux-ignore";
// src
import events from "./events";
import presets from "./presets";
import resources from "./resources";
import search from "./search";
import system from "./system";
import table from "./table";
import timeline from "./timeline";
import user from "./user";
import ux from "./ux";

const match = (regex) => ({ type }) => regex.test(type);

const eventsRegex = /^(events|user|system\/hydrate)/;
const presetsRegex = /^(events|presets|user|system\/hydrate)/;
const resourcesRegex = /^(resources|system\/hydrate)/;
const searchRegex = /^search/;
const systemRegex = /^system/;
const tableRegex = /^(table|events|system\/hydrate)/;
const timelineRegex = /^(timeline|table|system\/hydrate)/;
const userRegex = /^(user|system\/hydrate)/;
const uxRegex = /^(ux|system\/hydrate)/;

export default combineReducers({
  events: filterActions(events, match(eventsRegex)),
  presets: filterActions(presets, match(presetsRegex)),
  resources: filterActions(resources, match(resourcesRegex)),
  search: filterActions(search, match(searchRegex)),
  system: filterActions(system, match(systemRegex)),
  table: filterActions(table, match(tableRegex)),
  timeline: filterActions(timeline, match(timelineRegex)),
  user: filterActions(user, match(userRegex)),
  ux: filterActions(ux, match(uxRegex)),
});
